import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useAdminAuth } from "@/admin/hooks/useAdminAuth";

interface Props {
  children: ReactNode;
}

/**
 * Guard de route : redirige vers /connexion si l'utilisateur n'est pas admin.
 */
export function AdminRoute({ children }: Props) {
  const { isAdmin, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/fr/connexion" replace />;
  }

  return <>{children}</>;
}
